import Vue from "vue";
import VueWaypoint from "vue-waypoint";

// Waypoint plugin
Vue.use(VueWaypoint);
